import { Routes, Route, Navigate } from 'react-router-dom';
import { SingleCard } from './layouts';
import { ResetPasswordForm, ChangePasswordForm, CreateAccountForm } from './components';
import MyLoginPages from './pages/myLoginPages/MyLoginPages';
import FeedbackPwdPage from './pages/myLoginPages/FeedbackPwdPage';
import Home from './pages/home/home';

export default function UnauthenticatedContent() {
  return (
    <Routes>
      <Route
        path='/login' 
        element={
          // <SingleCard title="Sign In">
            // <LoginForm />
          // </SingleCard>
          <MyLoginPages />
        }
      />
      <Route
        path='/feedbackPasswordPage' 
        element={
          <FeedbackPwdPage />
        }
      />
      {/* <Route
        path='/create-account'
        element={
          <SingleCard title="Sign Up">
            <CreateAccountForm />
          </SingleCard>
        }
      /> */}
      {/* <Route 
        path='/reset-password'
        element={
          <SingleCard
            title="Reset Password"
            description="Please enter the email address that you used to register, and we will send you a link to reset your password via Email."
          >
            <ResetPasswordForm />
          </SingleCard>
        }
      /> */}
      {/* <Route
        path='/change-password/:recoveryCode'
        element={
          <SingleCard title="Change Password">
            <ChangePasswordForm />
          </SingleCard>
        }
      /> */}
      <Route path='*' element={<Home/>}></Route>
    </Routes>
  );
}
